import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";
import { CircularProgress, Backdrop } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./i18n";
import "./index.css";

const theme = createTheme({
    typography: { fontFamily: `"Noto Sans", sans-serif`, fontSize: 16 },
});

const loading = (
    <div
        style={{
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
        }}
    >
        <Backdrop
            sx={{
                color: "#fff",
                zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={true}
        >
            <CircularProgress style={{ color: "orange" }} />
        </Backdrop>
    </div>
);

const tree = (
    <React.StrictMode>
        <Suspense fallback={loading}>
            <HelmetProvider>
                <BrowserRouter>
                    <ThemeProvider theme={theme}>
                        <App />
                    </ThemeProvider>
                </BrowserRouter>
            </HelmetProvider>
        </Suspense>
    </React.StrictMode>
);

const rootEl = document.getElementById("root") as HTMLElement;

// react-snap prerenders static HTML at build time; hydrate it when present,
// otherwise mount fresh (dev server).
if (rootEl.hasChildNodes()) {
    ReactDOM.hydrateRoot(rootEl, tree);
} else {
    ReactDOM.createRoot(rootEl).render(tree);
}

reportWebVitals();
